import config from "../config";
import sendRequest from "../helpers/requestHelper";
import eventBus from "../event-bus/eventBus";

const languageMain = {
    namespaced: true,
    state: {
        languageData: [],
        isPreloadingLanguage: true,
        language: "gb",
        activeCountry: 'gb',
    },
    mutations: {
        GET_TEMPLATE_SUCCESS(state, response) {
            state.languageData = response.data;
            state.isPreloadingLanguage = false;
            eventBus.$emit("getLanguageSuccess");
        },
        GET_TEMPLATE_FAILURE(state, error) {
            console.log(error);
        }
    },
    actions: {
        updateCountry: function({state}, value) {
            localStorage.setItem("country", value);
            state.activeCountry = value;
        },
        updateLanguageTemplate: function({dispatch, state}, value) {
            state.languageData = [];
            localStorage.setItem("language", value.language);
            state.language = value.language;
            dispatch("getTemplateLang", value);
        },
        getTemplateLang: function({dispatch}, value) {
            var headers = {};
            let auth = false;

            var templateNotAuth = ["users/password/reset", "users/password/forget", "users/login"];

            if(!templateNotAuth.includes(value.template)) {
                auth = true;
                headers = {
                    "Authorization": "Bearer "+localStorage.getItem("tokenAuth")
                }
            }


            var promise = sendRequest("get", config.baseURLApi+'/language/template' , headers, {}, auth, value);

            promise.then(function($result) {
                if($result[0] === "success") {
                    dispatch("successGetTemplate", $result[1]);
                } else {
                    dispatch("failureGetTemplate", $result[1]);
                }
            });
        },
        successGetTemplate({commit}, response) {
            commit("GET_TEMPLATE_SUCCESS", response);
        },
        failureGetTemplate({commit}, error) {
            commit("GET_TEMPLATE_FAILURE", error);
        }
    }
}

export default languageMain;
